import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { switchMap, filter, take, map } from 'rxjs/operators';

import { GTMInitializationError, GTMInitializationErrorMessages } from '../models/google-services.errors';

import {
    Init,
    InitGoogleTagManagerError,
    InitGoogleTagManagerSuccess,
} from './google-services.actions';

import { getCmsConfigValue } from '@core/infrastructure/state/core.selectors';
import { UserConsentService } from '@core/ui/services/user-consent.service';

@Injectable()
export class GoogleServicesEffects {
    constructor(
        private readonly actions$: Actions,
        private readonly store: Store,
        private readonly userConsentService: UserConsentService
    ) { }

    public initGoogleTagManager$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(Init),
            concatLatestFrom(() => this.store.select(getCmsConfigValue('enabled_gtm'))),
            filter(([_, enabledGTM]) => !!enabledGTM),
            switchMap(() => this.userConsentService.waitForAnalyticsCookieConsent().pipe(take(1))),
            map((hasTheUserConsented) => {
                if (!hasTheUserConsented) {
                    const error = new GTMInitializationError(GTMInitializationErrorMessages.USER_DOES_NOT_CONSENT);
                    return InitGoogleTagManagerError({ error });
                }

                return InitGoogleTagManagerSuccess();
            }),
        );
    });
}
